import Header from "@/components/header";
import { useAuth } from "@/context/auth";
import useIsSmall from "@/hooks/useIsSmall";
import { MerchantUserDto, MerchantUserType, VerificationStatus } from "@/models/club";
import { useGetMerchantForMerchantUser } from "@/services/merchant/utilities";
import { useGetVerification } from "@/services/verification/hooks/useGetVerification";
import { CustomLink } from "@/styles/shared/link/link.style";
import {
  Avatar,
  Button,
  Card,
  Container,
  Group,
  Indicator,
  Menu,
  Modal,
  Skeleton,
  Stack,
  Text,
  Title,
} from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import {
  IconAddressBook,
  IconAward,
  IconBell,
  IconChevronLeft,
  IconFileCertificate,
  IconFingerprint,
  IconHome,
  IconLogout,
  IconMailbox,
  IconUser,
} from "@tabler/icons-react";
import { useNavigate } from "react-router-dom";
import useGetMerchant from "./hooks/useGetMerchant";

function ProfileHome() {
  // const { data, isLoading } = useGetMerchant();
  const { getUserByToken } = useAuth();
  const { data: merchant } = useGetMerchant();
  const { data: merchantUser, isLoading } = useGetMerchantForMerchantUser(
    getUserByToken()?.phoneNumber ?? ""
  );

  const user = merchantUser as MerchantUserDto;

  const isAdmin = merchantUser?.merchantUserType === MerchantUserType.Value0;
  const isMainAdmin = getUserByToken()?.phoneNumber === merchant?.phoneNumber;

  const { logout } = useAuth();
  const navigate = useNavigate();
  const [opened, { open, close }] = useDisclosure(false);

  const { data } =
    useGetVerification({ isAdmin: isAdmin && isMainAdmin });
  const isSmall = useIsSmall();
  return (
    <>
      {
        isSmall && <Header
          title="اطلاعات مجموعه"
          showBack
          route="/dashboard"
          bg={isSmall ? "light-gray.0" : ""}
        />
      }

      <Container w="100%" size="md" bg={isSmall ? "light-gray.0" : ""}>
        <Title order={4}> اطلاعات کاربری </Title>

        <Stack

          mt={!isSmall ? "xl" : ""}
          bg={isSmall ? "light-gray.0" : ""}
        >
          {isSmall ? (
            <Card px="0" bg={isSmall ? "light-gray.0" : ""} pb="0">
              <Group justify="space-between">
                <Group gap="xs">
                  <Avatar radius="xl" size="lg" />
                  <Text>
                    {isLoading ? (
                      <Skeleton />
                    ) : (
                      <Text>
                        {user?.firstName} {user?.lastName}
                      </Text>
                    )}
                  </Text>
                </Group>
                <IconHome onClick={() => navigate("/")} />
              </Group>
            </Card>
          ) : (
            <></>
          )}

          <Stack gap="xs">
            <Card withBorder>
              <Menu>
                {/* {user?.merchantUserType === MerchantUserType.Value2 ? (
                <></>
              ) : (
                s<CustomLink to="edit">
                  <Menu.Item
                    mt="xs"
                    leftSection={<IconEdit size={20} stroke={1.5} />}
                    rightSection={<IconChevronLeft size={20} stroke={1} />}
                  >
                    <Text fw={500}> ویرایش اطلاعات </Text>
                  </Menu.Item>
                </CustomLink>
              )} */}

                {/* <CustomLink to="transaction" style={{ textDecoration: "none" }}>
                <Menu.Item
                  mt="xs"
                  leftSection={<IconCashBanknote size={20} stroke={1.5} />}
                  rightSection={<IconChevronLeft size={20} stroke={1} />}
                >
                  <Text fw={500}> تراکنش ها </Text>
                </Menu.Item>
              </CustomLink> */}

                <CustomLink to="edit/information">
                  <Menu.Item
                    mt="xs"
                    leftSection={<IconUser size={20} stroke={1.5} />}
                    rightSection={<IconChevronLeft size={20} stroke={1} />}

                  >
                    <Text fw={500}> اطلاعات فردی </Text>
                  </Menu.Item>
                </CustomLink>
                <CustomLink to="referralCode" style={{ textDecoration: "none" }}>
                  <Menu.Item
                    mt="xs"
                    leftSection={<IconMailbox size={20} stroke={1.5} />}
                    rightSection={<IconChevronLeft size={20} stroke={1} />}
                    disabled={!isAdmin}
                  >
                    <Text fw={500}> دعوت از دوستان </Text>
                  </Menu.Item>
                </CustomLink>
                <CustomLink to="notifications" style={{ textDecoration: "none" }}>
                  <Menu.Item
                    mt="xs"
                    leftSection={<IconBell size={20} stroke={1.5} />}
                    rightSection={<IconChevronLeft size={20} stroke={1} />}
                    disabled={!isAdmin}
                  >
                    <Text fw={500}> اعلان ها </Text>
                  </Menu.Item>
                </CustomLink>

                <CustomLink to="servicePrice" style={{ textDecoration: "none" }}>
                  <Menu.Item
                    mt="xs"
                    leftSection={<IconAward size={20} stroke={1.5} />}
                    rightSection={<IconChevronLeft size={20} stroke={1} />}
                    disabled={!isAdmin}
                  >
                    <Text fw={500}> هزینه تعرفه ها </Text>
                  </Menu.Item>
                </CustomLink>
                <CustomLink
                  to="/dashboard/profile/importContact"
                  style={{ textDecoration: "none" }}
                >
                  <Menu.Item
                    mt="xs"
                    leftSection={<IconAddressBook size={20} stroke={1.5} />}
                    rightSection={<IconChevronLeft size={20} stroke={1} />}

                  >
                    <Text fw={500}> افزودن مخاطبین از تلفن همراه </Text>
                  </Menu.Item>
                </CustomLink>
                <CustomLink
                  to={data?.status !== 2 ? "verification" : "verification/result"}
                >
                  <Menu.Item
                    mt="xs"
                    leftSection={
                      data ? (
                        <Indicator
                          inline
                          processing
                          disabled={data?.status !== VerificationStatus.Value0}
                          color="blue"
                          onClick={open}
                        >
                          <IconFingerprint
                            size="1.5rem"
                            color={
                              data?.status === 1
                                ? "orange"
                                : data?.status === 2
                                  ? "green"
                                  : data?.status === 3
                                    ? "red"
                                    : "gray"
                            }
                            stroke={1.5}
                          />
                        </Indicator>
                      ) : (
                        <IconFingerprint
                          size="1.5rem"
                          color="gray"
                          stroke={1.5}
                        />
                      )
                    }
                    rightSection={<IconChevronLeft size={20} stroke={1} />}
                    disabled={!isAdmin && isMainAdmin}
                  >
                    <Group gap="xs">
                      <Text fw={500}>تایید هویت </Text>
                      <Text size="xs" c="dimmed">
                        {data?.status === 1
                          ? "(دردست بررسی)"
                          : data?.status === 2
                            ? "(تایید شده)"
                            : data?.status === 3
                              ? "(رد شده)"
                              : ""}
                      </Text>
                    </Group>
                  </Menu.Item>
                </CustomLink>
                <CustomLink
                  to="termsAndCondition"
                  style={{ textDecoration: "none" }}
                >
                  <Menu.Item
                    mt="xs"
                    leftSection={<IconFileCertificate size={20} stroke={1.5} />}
                    rightSection={<IconChevronLeft size={20} stroke={1} />}
                  >
                    <Text fw={500}> قوانین و مقررات </Text>
                  </Menu.Item>
                </CustomLink>

                <CustomLink
                  to=""
                  onClick={open}
                  style={{ textDecoration: "none" }}
                >
                  <Menu.Item
                    mt="xs"
                    leftSection={
                      <IconLogout
                        color="var(--mantine-color-red-7)"
                        size={20}
                        stroke={1.5}
                      />
                    }
                    rightSection={<IconChevronLeft size={20} stroke={1} />}
                  >
                    <Text c="red" fw={500}>
                      {" "}
                      خروج{" "}
                    </Text>
                  </Menu.Item>
                </CustomLink>
              </Menu>
            </Card>
          </Stack>
          <Modal centered opened={opened} onClose={close} title="">
            <Stack>
              <Text size="xs">آیا از خروج اطمینان دارید ؟</Text>
              <Group gap="xs">
                <Button size="xs" color="red" onClick={logout}>
                  بلی
                </Button>
                <Button size="xs" variant="outline" onClick={close}>
                  انصراف
                </Button>
              </Group>
            </Stack>
          </Modal>
        </Stack>
      </Container>
    </>
  );
}

export default ProfileHome;
